module.exports = __webpack_public_path__ + "static/media/skillet.b1d16d0d.svg";